import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSpacePath } from '../../../hooks/useSpacePath';
import { usePermissions } from '../../../hooks/usePermissions';
import { ProviderDatabase } from '../../../types';
import { useGetProvidersCount } from '../api/useGetProvidersCount';

export function useProvidersListPage() {
  const navigate = useNavigate();
  const spacePath = useSpacePath();
  const { isAdmin } = usePermissions();
  const [isAddModalOpened, setIsAddModalOpened] = useState(false);
  const [isManageTagsModalOpened, setIsManageTagsModalOpened] = useState(false);
  const { data: count = 0 } = useGetProvidersCount();

  const subtitle = count > 0 ? `${count} prestataire${count > 1 ? 's' : ''}` : undefined;

  function handleOpenAddModal() {
    setIsAddModalOpened(true);
  }

  function handleCloseAddModal() {
    setIsAddModalOpened(false);
  }

  function handleOpenManageTagsModal() {
    setIsManageTagsModalOpened(true);
  }

  function handleCloseManageTagsModal() {
    setIsManageTagsModalOpened(false);
  }

  function handleProviderCreated(provider?: ProviderDatabase) {
    if (provider) {
      navigate(spacePath(`/providers/${provider.id}`));
    }
  }

  return {
    isAdmin,
    subtitle,
    isAddModalOpened,
    isManageTagsModalOpened,
    handleOpenAddModal,
    handleCloseAddModal,
    handleOpenManageTagsModal,
    handleCloseManageTagsModal,
    handleProviderCreated,
  };
}
